import { objectKeys } from "utils/typescript";

import { ConnectionStatusFilterState } from "../Companies";

/**
 *
 * @param query The ConnectionFilterState object
 * @returns Query string with correct properties
 */
export function buildDataConnectionsQuery(query: ConnectionStatusFilterState) {
  if (objectKeys(query).every((key) => !!query[key])) {
    return "";
  }
  return objectKeys(query)
    .filter((key) => query[key])
    .map((key) => `dataConnections.status=${key}`)
    .join("||");
}

/**
 *
 * @param params The URL search params from the current URL
 * @returns ConnectionFilterState object with the correct values based on the URL params
 */
export function mapParamsToState(
  params: URLSearchParams
): ConnectionStatusFilterState {
  const statusesArray = (params.get("dataConnectionStatus") ?? "")
    .split("||")
    .filter(Boolean);

  return {
    Linked: statusesArray.includes("Linked"),
    PendingAuth: statusesArray.includes("PendingAuth"),
    Deauthorized: statusesArray.includes("Deauthorized"),
    Unlinked: statusesArray.includes("Unlinked"),
  };
}

/**
 *
 * @param text The search query (text-based search)
 * @returns Query string with correct properties
 */
export function buildSearchQuery(text: string) {
  if (!text) return "";
  return [
    { field: "id", func: "~" },
    { field: "name", func: "~" },
    { field: "createdByUserName", func: "~" },
    { field: "platform", func: `~` },
  ]
    .map((f) => f.field + f.func + text)
    .join("||");
}

/**
 *
 * @param searchQuery The search query (text-based search)
 * @param dataConnectionsQuery The data connections query (filter by connection status)
 * @returns Combined query string joined by && operator
 */
export function combineApiQueries(
  searchQuery: string,
  dataConnectionsQuery: string
) {
  if (!searchQuery) return dataConnectionsQuery;
  if (!dataConnectionsQuery) return searchQuery;
  return `{${searchQuery}}&&{${dataConnectionsQuery}}`;
}
